module.exports = __webpack_public_path__ + "img/2-7-5.1a22db43.png";